import { createAPIMethod } from 'utils/generic';
import {
	type LocalityData,
	type LocalitySuggestionData,
	normalizeLocality,
	normalizeLocalitySuggestion,
	type ResponseLocalitySuggestionData,
} from './model.ts';

export const SuggestTypes = {
	REGIONAL: 'regional',
	REGIONAL_COUNTRY: 'regional.country',
	REGIONAL_REGION: 'regional.region',
	REGIONAL_MUNICIPALITY: 'regional.municipality',
	REGIONAL_MUNICIPALITY_PART: 'regional.municipality_part',
	REGIONAL_STREET: 'regional.street',
	REGIONAL_ADDRESS: 'regional.address',
	POI: 'poi',
	COORDINATE: 'coordinate',
} as const;

export type SuggestTypeValues = (typeof SuggestTypes)[keyof typeof SuggestTypes];

const MONTH_IN_MS = 30 * 24 * 60 * 60 * 1000;

export async function getLocalitySuggestions(
	{
		query,
		type,
	}: {
		query: string;
		type?: SuggestTypeValues | SuggestTypeValues[]; // values of SuggestTypes;
	},
	headers?: HeadersInit,
) {
	return createAPIMethod<object, LocalitySuggestionData[]>({
		apiPath: '/api/v2',
		path: `/localities/suggest`,
		method: 'GET',
		normalize: ({ results }) =>
			results.map((result: ResponseLocalitySuggestionData) => normalizeLocalitySuggestion(result)),
		headers,
		useCache: true,
		cacheTtl: 60 * 60 * 1000,
	})(Array.isArray(type) ? { query, type: type.join(',') } : { query, type });
}

export type ResolveLocalityParams = {
	entity_id: number;
	entity_type: string;
};

type GetLocalityByGpsParams = {
	gps_lat: number;
	gps_lon: number;
};

export async function resolveLocality(params: ResolveLocalityParams | GetLocalityByGpsParams, headers?: HeadersInit) {
	return createAPIMethod<object, LocalityData>({
		path: `/localities/resolve`,
		method: 'GET',
		normalize: ({ result }) => normalizeLocality(result),
		useCache: true,
		cacheTtl: MONTH_IN_MS,
		headers,
	})(params);
}
